export const environment = {
  production: false,
  apiUrl: "https://core.diaq.in/api/",
  dap_imageUrl: "https://node.diaq.in/",
  dap_weatherUrl: "https://api.weatherapi.com/v1/",
  dap_url: "https://node.diaq.in/",
};

//https://core-ce.diaq.in/
